import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumb(props) {
  const { addClass = "", crumbs } = props;

  return (
    <nav aria-label="breadcrumb" className={`breadcrumb-nav ${addClass}`}>
      <div className="container">
        <ol className="breadcrumb">
          {
            crumbs.map((item, index) => {
              return (
                <li className="breadcrumb-item align-items-center" key={index}>
                  <Link to={`${item.path}`} className={item.style}>{item.name}</Link>
                </li>
              );
            })
          }
        </ol>
      </div>
    </nav>
  );
}

export default Breadcrumb;